function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import * as StyledComps from '../StyledComps';
export var Render = /*#__PURE__*/function (_Component) {
  _inherits(Render, _Component);

  var _super = _createSuper(Render);

  function Render() {
    var _this;

    _classCallCheck(this, Render);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "updateLightbox", function (isOpen) {
      return function () {
        var region = _this.props.region;

        if (isOpen) {
          _this.props.handleViewerEvent('regionClick', {
            region: region
          });
        }

        _this.setState({
          isOpen: isOpen
        });
      };
    });

    return _this;
  }

  _createClass(Render, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          region = _this$props.region,
          debug = _this$props.debug,
          modalRef = _this$props.modalRef;
      var isOpen = this.state.isOpen;
      var size = {
        width: region.settings.width ? region.settings.width : 16,
        height: region.settings.height ? region.settings.height : 9,
        maxWidth: region.settings.maxWidth ? region.settings.maxWidth : false
      };
      return region.settings.iframe ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
        onClick: this.updateLightbox(true)
      }, debug ? region['@id'] : null), modalRef && modalRef.current !== null ? /*#__PURE__*/React.createElement(Modal, {
        open: isOpen,
        onClose: this.updateLightbox(false),
        center: true,
        closeOnEsc: !!region.settings.backdropExit,
        closeOnOverlayClick: !!region.settings.backdropExit,
        classNames: StyledComps.classes.iframe,
        styles: {
          modal: {
            background: 'transparent',
            maxWidth: "".concat(size && size.maxWidth ? "".concat(size.maxWidth, "px") : '80%')
          }
        },
        container: modalRef.current
      }, /*#__PURE__*/React.createElement(StyledComps.PageLightboxIframeWrapper, {
        size: size,
        dangerouslySetInnerHTML: {
          __html: region.settings.iframe
        }
      })) : null) : null;
    }
  }]);

  return Render;
}(Component);
Render.propTypes = {
  region: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  handleViewerEvent: PropTypes.func.isRequired,
  pageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  debug: PropTypes.bool
};
Render.defaultProps = {
  region: null,
  onPageChange: null,
  debug: false
};
export default Render;